__webpack_require__.p = "/flipAndDiscover/";